import React from 'react'
import AboutHero from './AboutHero'
import WhoWeAre from './WhoWeAre'
import OurStory from './OurStory'
import AboutSection from './AboutSection'
import OurValue from './OurValue'

const About = () => {
  return (
    <div>
      <AboutHero/>
      <WhoWeAre/>
      <OurStory/>
      <AboutSection/>
      <OurValue/>
    </div>
  )
}

export default About